/* tslint:disable */
/* eslint-disable */
/**
 * Vayu API
 * The Vayu API is a RESTful API that allows you to submit events for processing and storage & manage billing related entities.           The API is secured using the Bearer Authentication scheme with JWT tokens.           To obtain a JWT token, please contact Vayu at team@withvayu.com
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dev@withvayu.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    CommercialTermsPricingInput,
    instanceOfCommercialTermsPricingInput,
    CommercialTermsPricingInputFromJSON,
    CommercialTermsPricingInputFromJSONTyped,
    CommercialTermsPricingInputToJSON,
} from './CommercialTermsPricingInput';
import {
    CommissionPricingInput,
    instanceOfCommissionPricingInput,
    CommissionPricingInputFromJSON,
    CommissionPricingInputFromJSONTyped,
    CommissionPricingInputToJSON,
} from './CommissionPricingInput';
import {
    FixedPerUnitPricingInput,
    instanceOfFixedPerUnitPricingInput,
    FixedPerUnitPricingInputFromJSON,
    FixedPerUnitPricingInputFromJSONTyped,
    FixedPerUnitPricingInputToJSON,
} from './FixedPerUnitPricingInput';
import {
    InstallmentsPricingInput,
    instanceOfInstallmentsPricingInput,
    InstallmentsPricingInputFromJSON,
    InstallmentsPricingInputFromJSONTyped,
    InstallmentsPricingInputToJSON,
} from './InstallmentsPricingInput';
import {
    OneTimePricingInput,
    instanceOfOneTimePricingInput,
    OneTimePricingInputFromJSON,
    OneTimePricingInputFromJSONTyped,
    OneTimePricingInputToJSON,
} from './OneTimePricingInput';
import {
    PerUnitPricingInput,
    instanceOfPerUnitPricingInput,
    PerUnitPricingInputFromJSON,
    PerUnitPricingInputFromJSONTyped,
    PerUnitPricingInputToJSON,
} from './PerUnitPricingInput';
import {
    RecurringPricingInput,
    instanceOfRecurringPricingInput,
    RecurringPricingInputFromJSON,
    RecurringPricingInputFromJSONTyped,
    RecurringPricingInputToJSON,
} from './RecurringPricingInput';
import {
    RefundPricingInput,
    instanceOfRefundPricingInput,
    RefundPricingInputFromJSON,
    RefundPricingInputFromJSONTyped,
    RefundPricingInputToJSON,
} from './RefundPricingInput';
import {
    TieredSubscriptionPricingInput,
    instanceOfTieredSubscriptionPricingInput,
    TieredSubscriptionPricingInputFromJSON,
    TieredSubscriptionPricingInputFromJSONTyped,
    TieredSubscriptionPricingInputToJSON,
} from './TieredSubscriptionPricingInput';
import {
    TiersPricingInput,
    instanceOfTiersPricingInput,
    TiersPricingInputFromJSON,
    TiersPricingInputFromJSONTyped,
    TiersPricingInputToJSON,
} from './TiersPricingInput';

/**
 * @type PricingInput
 * 
 * @export
 */
export type PricingInput = { pricingModel: 'CommercialTerms' } & CommercialTermsPricingInput | { pricingModel: 'Commission' } & CommissionPricingInput | { pricingModel: 'FixedOneTime' } & OneTimePricingInput | { pricingModel: 'FixedPerUnit' } & FixedPerUnitPricingInput | { pricingModel: 'Installments' } & InstallmentsPricingInput | { pricingModel: 'PerUnit' } & PerUnitPricingInput | { pricingModel: 'Refund' } & RefundPricingInput | { pricingModel: 'Subscription' } & RecurringPricingInput | { pricingModel: 'TieredSubscription' } & TieredSubscriptionPricingInput | { pricingModel: 'Tiers' } & TiersPricingInput;

export function PricingInputFromJSON(json: any): PricingInput {
    return PricingInputFromJSONTyped(json, false);
}

export function PricingInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PricingInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['pricingModel']) {
        case 'CommercialTerms':
            return {...CommercialTermsPricingInputFromJSONTyped(json, true), pricingModel: 'CommercialTerms'};
        case 'Commission':
            return {...CommissionPricingInputFromJSONTyped(json, true), pricingModel: 'Commission'};
        case 'FixedOneTime':
            return {...OneTimePricingInputFromJSONTyped(json, true), pricingModel: 'FixedOneTime'};
        case 'FixedPerUnit':
            return {...FixedPerUnitPricingInputFromJSONTyped(json, true), pricingModel: 'FixedPerUnit'};
        case 'Installments':
            return {...InstallmentsPricingInputFromJSONTyped(json, true), pricingModel: 'Installments'};
        case 'PerUnit':
            return {...PerUnitPricingInputFromJSONTyped(json, true), pricingModel: 'PerUnit'};
        case 'Refund':
            return {...RefundPricingInputFromJSONTyped(json, true), pricingModel: 'Refund'};
        case 'Subscription':
            return {...RecurringPricingInputFromJSONTyped(json, true), pricingModel: 'Subscription'};
        case 'TieredSubscription':
            return {...TieredSubscriptionPricingInputFromJSONTyped(json, true), pricingModel: 'TieredSubscription'};
        case 'Tiers':
            return {...TiersPricingInputFromJSONTyped(json, true), pricingModel: 'Tiers'};
        default:
            throw new Error(`No variant of PricingInput exists with 'pricingModel=${json['pricingModel']}'`);
    }
}

export function PricingInputToJSON(value?: PricingInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['pricingModel']) {
        case 'CommercialTerms':
            return CommercialTermsPricingInputToJSON(value);
        case 'Commission':
            return CommissionPricingInputToJSON(value);
        case 'FixedOneTime':
            return OneTimePricingInputToJSON(value);
        case 'FixedPerUnit':
            return FixedPerUnitPricingInputToJSON(value);
        case 'Installments':
            return InstallmentsPricingInputToJSON(value);
        case 'PerUnit':
            return PerUnitPricingInputToJSON(value);
        case 'Refund':
            return RefundPricingInputToJSON(value);
        case 'Subscription':
            return RecurringPricingInputToJSON(value);
        case 'TieredSubscription':
            return TieredSubscriptionPricingInputToJSON(value);
        case 'Tiers':
            return TiersPricingInputToJSON(value);
        default:
            throw new Error(`No variant of PricingInput exists with 'pricingModel=${value['pricingModel']}'`);
    }

}

